import { useCallback } from "react";
import { useSheetSignature as useSheetSignatureBase } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";

// scoreadmin wrapper around common-fe's useSheetSignature (card #735): wires
// score-api's getScoreSheetSignature as the fetcher, matching the
// useRideStatuses wrapper pattern (../hooks/useRideStatuses.js). Pass
// `enabled` (the sheet's signed state, e.g. `Boolean(activeSheet?.completedAt)`)
// so the fetch only happens once a signature actually exists to show.
export function useSheetSignature(sheetId, opts) {
  const scoreApi = useScoreApi();
  const fetchSignature = useCallback(
    async (id) => unwrap(await scoreApi.scoreSheets.getScoreSheetSignature(id)),
    [scoreApi],
  );
  return useSheetSignatureBase(sheetId, fetchSignature, opts);
}

export default useSheetSignature;
